import { LoginMain } from "../../styles/login";
import { FormLogin } from "./loginForm";

export const Login = () => {
  return (
    <LoginMain>
      <div className="teste"></div>
      <FormLogin />
    </LoginMain>
  );
};
